import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { MxIdentityService } from '../services';

@Injectable({ providedIn: 'root' })
export class MxAuthGuard implements CanActivate {
  constructor(private router: Router, private identityService: MxIdentityService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const account = this.identityService.accountValue;
    if (!account) {
      this.router.navigate(['pages', 'login'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
    return true;
  }
}
